import { render, staticRenderFns } from "./ModalContent.vue?vue&type=template&id=5cb05188&scoped=true&"
import script from "./ModalContent.vue?vue&type=script&lang=ts&"
export * from "./ModalContent.vue?vue&type=script&lang=ts&"
import style0 from "./ModalContent.vue?vue&type=style&index=0&id=5cb05188&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb05188",
  null
  
)

export default component.exports